import { Flex, HStack, Tag } from "@chakra-ui/react";
import PrimaryButton from "ui/components/Button/PrimaryButton";
import InputSearch from "ui/components/Input/InputSearch";
import FiltroTipoAreaComum from "../../FiltroTipoAreaComum";
import { getTagColor, getTypeTag } from "../../../util/helper";
import { StatusReservaEnum } from "core/features/reservas/typings";

export interface HeaderTableProps {
  onSearch: (q?: string) => void;
  value: string;
  view: "CALENDARIO" | "LISTA";
  selectedTipoAreaComum?: string;
  setSelectedTipoAreaComum?: (type?: string) => any;
  onChangeView?: () => any;
}

function HeaderTable({
  onSearch,
  value,
  selectedTipoAreaComum,
  setSelectedTipoAreaComum,
  onChangeView,
  view,
}: HeaderTableProps) {
  return (
    <Flex flexDir="column">
      <Flex gridGap="16px">
        <Flex maxW="450px" zIndex={0}>
          <InputSearch defaultValue={value} onSearch={(v) => onSearch(v)} />
        </Flex>
        <HStack pl="16px" gap="0.1rem" justifyContent="center">
          <Tag
            rounded="full"
            variant="outline"
            colorScheme={getTagColor(StatusReservaEnum.AguardandoPagamento)}
          >
            {getTypeTag(StatusReservaEnum.AguardandoPagamento)}
          </Tag>
          <Tag
            rounded="full"
            variant="outline"
            colorScheme={getTagColor(StatusReservaEnum.Confirmada)}
          >
            {getTypeTag(StatusReservaEnum.Confirmada)}
          </Tag>
          <Tag rounded="full" variant="outline" colorScheme={"cyan"}>
            {getTypeTag(StatusReservaEnum.Pendente)}
          </Tag>
          <Tag
            rounded="full"
            variant="outline"
            colorScheme={getTagColor(StatusReservaEnum.Cancelada)}
          >
            {getTypeTag(StatusReservaEnum.Cancelada)}
          </Tag>
        </HStack>

        <Flex flex={1}>
          <Flex gridGap="16px" ml="auto">
            <FiltroTipoAreaComum
              selectedTipoAreaComum={selectedTipoAreaComum}
              setSelectedTipoAreaComum={setSelectedTipoAreaComum}
            />

            <PrimaryButton onClick={onChangeView}>
              Ver {view === "LISTA" ? "calendário" : "lista"}
            </PrimaryButton>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
}

export default HeaderTable;
